import { logger } from '@/shared/utils';
import { WebCamera } from '@/components/WebCamera';
import { useMediaFile } from '@/features/chats/sub-features/media/viewmodel/useMediaFile';
import { hidePopup } from '@/components/PopupContainer/popupService';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

const AttachmentWebCamera = ({ activeChatId }) => {
   const { openMediaPreview } = useMediaFile({ activeChatId });

   const handleCameraCapture = useCallback(
      ({ file }) => {
         try {
            hidePopup('attachment_web_camera_popup');
            openMediaPreview(file, 'image', true, { isCameraCapture: true });
         } catch (error) {
            logger.error('Failed to capture:', error);
         }
      },
      [openMediaPreview],
   );

   return <WebCamera onCapture={handleCameraCapture} onClose={hidePopup} />;
};

AttachmentWebCamera.propTypes = {
   activeChatId: PropTypes.string.isRequired,
};

export default React.memo(AttachmentWebCamera);
